import React from "react";
import HierarchicalRefinementList from "components/search/base/HierarchicalRefinementList";
import guideCategories from "components/search/references/guideCategories";

const GuideRefinementList = () => {
  return (
    <HierarchicalRefinementList
      attribute="category"
      categories={guideCategories}
      limit={20}
      title="Type of Guide"
    />
  );
};

export default GuideRefinementList;
